import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAtmedAssets, updateAssetStatus, deleteAssets,
} from '../../../store/actions';
import ImageApproval from './ImageApproval';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  atmedAssets: vendorEquipmenReducer.atmedAssets,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAtmedAssets,
    updateAssetStatus,
    deleteAssets,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ImageApproval);
